import CASL from '@/utils/constants/casl'

export default {
  path: 'dealer-user',
  children: [
    {
      path: '',
      name: 'dealer-user.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DEALER_USER
      },
      component: () => import('./list/DealerUserListPage.vue')
    }
  ]
}
